

import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../data/axiosInstance/axiosInstance";
import executor from "../../../data/axiosInstance/executor";

import {
    openAlert,
    startLoading,
    stopLoading,
} from "../DataQualityStatus/DataQualitySlice";

import fetchUserListJson from "./fetchUserList.json";


const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;

const initialState = {

    userList: [],
    redXRoles: [],
};

const USE_API = true;

export const DataQualityAdminSlice = createSlice({
    name: "dataQualityAdmin",
    initialState,
    reducers: {
        setuserList: (state, action) => {
            state.userList = action.payload;
        },
        setRedXRoles: (state, action) => {
            state.redXRoles = action.payload;
        },
    },
});

export const { setuserList, setRedXRoles } = DataQualityAdminSlice.actions;



export const fetchUserList = () => async (dispatch) => {
    dispatch(startLoading());
    dispatch(setuserList([]));

    let res = null;
    let err = null;


    if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/adminOperation/getRedxUser`;
        const fetchData = async () => axiosInstance.get(API_URI_CALL);
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
            dispatch(
                openAlert({
                    message:

                        "Error retrieving users list: " +
                        err?.response?.headers?.apierror,
                    type: "danger",
                })
            );
        }
    } else {
        res = fetchUserListJson;
    }

    console.debug("fetchuserList res", res);
    dispatch(setuserList(res?.data || []));
    return dispatch(stopLoading());
};

export const fetchRedXRoles = () => async (dispatch) => {
    dispatch(startLoading());
    dispatch(setRedXRoles([]));

    let res = null;
    let err = null;


    if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/versions/rolesRedx`;
        const fetchData = async () => axiosInstance.get(API_URI_CALL);
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
            dispatch(
                openAlert({
                    message:
                        "Error retrieving RedX roles: " +
                        err?.response?.headers?.apierror,
                    type: "danger",
                })
            );
        }
    } else {
        // Mocked data for non-API mode
        res = {
            data: [
                {
                    "roleId": 0,
                    "roleName": "Reader",
                    "publisher": false,
                    "owner": false,
                    "admin": false
                },
                {
                    "roleId": 1,
                    "roleName": "Owner",
                    "publisher": false,
                    "owner": true,
                    "admin": false
                }
            ],
        };
    }

    console.debug("fetchRedXRoles res", res);
    dispatch(setRedXRoles(res?.data || []));
    return dispatch(stopLoading());
};


export const removeUser = (userName) => async (dispatch) => {
    dispatch(startLoading());
    let res = null;
    let err = null;

    if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/adminOperation/removeUser`;
        const fetchData = async () =>
            axiosInstance.get(API_URI_CALL, {
                params: {
                    userName: userName,
                }
            });
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
            dispatch(
                openAlert({
                    message: "Error removing user: " + err?.response?.headers?.apierror,
                    type: "danger",
                })
            );
        }
    }
    console.debug("removeUser res", res);
    return dispatch(stopLoading());
};

export const saveUser = (
    { userName, roleId, firstName, lastName, companyId, isValid },
    isUpdate = false
) => async (dispatch) => {
    dispatch(startLoading());

    let res = null;
    let err = null;

    if (USE_API) {
        const actionName = isUpdate ? "updateUser" : "addUser";
        const API_URI_CALL = `${API_URL}/api/v1/portal/adminOperation/${actionName}`;
        const fetchData = async () =>
            axiosInstance.get(API_URI_CALL, {
                params: {
                    userName,
                    roleId,
                    firstName,
                    lastName,
                    companyId,
                    isValid,
                },
            });
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
            console.error("saveUser error:", err?.response);
            dispatch(
                openAlert({
                    message: `Error ${isUpdate ? "updating" : "adding"} user: ` + (err?.response?.headers?.apierror || err?.message || ""),
                    type: "danger",
                })
            );
        }
    } else {
        // Non-API mode: no-op, could simulate success if needed
        console.debug(`saveUser (${isUpdate ? "update" : "add"}) mocked`);
    }

    console.debug("saveUser res", res);
    return dispatch(stopLoading());
};

export default DataQualityAdminSlice.reducer;


